// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5a78303","455":"e113f870","644":"6442b914"}[chunkId] + ".chunk.js";
};